export const languageList = [
    {lang:'en', langShort:'EN', title: "English", isrtl: false },    
    {lang:'ar', langShort:'مع', title: "عربى", isrtl: true },
    {lang:'ru', langShort:'Ру', title: "Русский", isrtl: false }
];

export const languageDefault = 'en';
export const languageFallback = 'en';

export interface LoaderState {
    show: boolean;
    multiCall: boolean;
}
export const ThreeDecimalCurrencies= ['BHD','OMR','KWD']


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/globalConfig.ts